<template>
  <section>
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.zcncode" placeholder="医院编号"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          border
          :max-height="tableHeight"
          :data="tabel_list"
          header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column prop="zcnCode" label="医院编号" width=""></el-table-column>
          <el-table-column prop="name" label="医院名称" width=""></el-table-column>
          <el-table-column prop="isDeleted" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isDeleted ? 'danger' : 'success'">
                {{ scope.row.isDeleted ? '已删除' : '使用中' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width=""></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-link type="primary" @click="handleEdit(scope.row)">
                <i class="el-icon-edit"></i>编辑
              </el-link>
              <el-link v-if="!scope.row.isDeleted" type="danger" @click="handleDelete(scope.row)" style="margin-left: 10px">
                <i class="el-icon-delete"></i>删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="addFormVisible" :close-on-click-modal="false" width="500px">
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="医院编号" required>
          <el-input :disabled="title == '编辑'" v-model="addForm.zcnCode" @input="validateZcnCode">
            <i slot="suffix" v-if="zcnCodeValid" class="el-icon-success" style="color: #67C23A; font-size: 18px; line-height: 40px;"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="医院名称" required>
          <el-input v-model="addForm.name" @input="validateName">
            <i slot="suffix" v-if="nameValid" class="el-icon-success" style="color: #67C23A; font-size: 18px; line-height: 40px;"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">关 闭</el-button>
        <el-button type="primary" @click="sbumits">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { flacs_gethcodata, dashboard_getregionsbylevel, flacs_createhco, flacs_edithco, flacs_deletehco } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      addForm: {},
      addFormVisible: false,
      title: '',
      city_list: [],
      area_list: [],
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      token: '',
      addLoading: false,
      addFormRules: {
        name: [{ required: false, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
        city: '',
        includeDeleted: false,  // 默认不显示已删除
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      nameValid: false, // 医院名称验证状态
      zcnCodeValid: false, // 医院编号验证状态
    }
  },
  methods: {
    // 验证医院名称是否包含汉字
    validateName() {
      const name = this.addForm.name || ''
      // 使用正则表达式检查是否包含汉字（\u4e00-\u9fa5）
      this.nameValid = /[\u4e00-\u9fa5]/.test(name)
    },
    // 验证医院编号是否包含数字
    validateZcnCode() {
      const zcnCode = this.addForm.zcnCode || ''
      // 使用正则表达式检查是否包含数字
      this.zcnCodeValid = /\d/.test(zcnCode)
    },
    async sbumits() {
      if (!this.addForm.name) {
        this.$message.error('请填写医院名称')
        return
      }
      if (!this.addForm.zcnCode) {
        this.$message.error('请填写医院编号')
        return
      }
      // 提交前重新验证，确保验证状态最新
      this.validateName()
      this.validateZcnCode()
      
      // 前端验证
      if (!this.nameValid) {
        this.$message.error('医院名称必须包含汉字')
        return
      }
      if (!this.zcnCodeValid) {
        this.$message.error('医院编号必须包含数字')
        return
      }
      if (this.title == '新增') {
        var { data } = await flacs_createhco(this.addForm)
      } else {
        var { data } = await flacs_edithco(this.addForm)
      }
      if (data.code == 200) {
        this.$message.success(data.msg)
        this.addFormVisible = false
        this.getModules_search()
      } else {
        this.$message.error(data.msg)
      }
    },
    async handleEdit(row) {
      this.title = '编辑'
      // 🔥 确保包含 id（后端通过 id 定位）
      this.addForm = {
        id: row.id,
        zcnCode: row.zcnCode,
        name: row.name
      }
      this.addFormVisible = true
      // 等待 Vue 更新响应式数据后再验证
      this.$nextTick(() => {
        this.validateName()
        this.validateZcnCode()
      })
    },
    async handleDelete(row) {
      this.$confirm(`确定要删除医院 "${row.name}" 吗？删除后不会影响历史数据。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await flacs_deletehco({ id: row.id })
        if (data.code == 200) {
          this.$message.success(data.msg)
          this.getModules_search()
        } else {
          this.$message.error(data.msg)
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleAdd() {
      this.title = '新增'
      this.addForm = {}
      this.nameValid = false
      this.zcnCodeValid = false
      this.addFormVisible = true
    },
    async dashboard_getregionsbylevel() {
      const { data } = await dashboard_getregionsbylevel()
      this.area_list = data.data.regions
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      this.listLoading = true
      flacs_gethcodata(para).then((res) => {
        this.total = res.data.dataCount
        this.tabel_list = res.data.data
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 230
        }
      })
    })
    this.getModules()
    this.dashboard_getregionsbylevel()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped></style>
